import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CloseHandlerService {
  public notSaved = false;
  public notSaveForm = new Subject();
  public clickSavePopup = new Subject();
}
